@if (isFormInitialized()) {
  <form class="flex flex-col p-2 pr-4 pb-20">
    <div
      class="grid grid-cols-2 items-start gap-4 py-2.5 border-b border-surface-switch-100"
    >
      <span class="text-sm text-surface-switch-600">Index</span>
      <span class="pt-2">{{ item.full_index | quoteItemIndex }}</span>
    </div>

    <div
      class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
    >
      <span class="text-sm text-surface-switch-600">Name</span>
      <div class="flex items-center gap-2 min-w-0">
        <input
          pInputText
          [formField]="editForm.name"
          type="text"
          class="w-full"
        />
        @if (editForm.name().dirty()) {
          <p-button
            icon="pi pi-undo"
            severity="secondary"
            [rounded]="true"
            (onClick)="resetName()"
            size="small"
          />
        }
      </div>
    </div>

    <div
      class="grid grid-cols-2 items-start gap-4 py-2.5 border-b border-surface-switch-100"
    >
      <span
        class="text-sm text-surface-switch-600 pt-2 flex items-center gap-1"
      >
        Material
        <i
          class="pi pi-info-circle text-xs text-muted-color cursor-pointer pl-1"
          pTooltip='Uses the existing materials on the Materials tab. "Inherit from Parent" uses the nearest ancestor item with a material set.'
          tooltipPosition="right"
        ></i>
      </span>
      <div class="flex flex-col gap-1 min-w-0">
        <div class="flex items-center gap-2 min-w-0">
          <app-material-select
            [formField]="editForm.material"
            class="flex-1 min-w-0"
          />
          @if (editForm.material().dirty()) {
            <p-button
              icon="pi pi-undo"
              severity="secondary"
              [rounded]="true"
              (onClick)="resetMaterial()"
              size="small"
            />
          }
        </div>
      </div>
    </div>

    @if (!item.children || item.children.length === 0) {
      <div
        class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
      >
        <span class="text-sm text-surface-switch-600 flex items-center gap-1">
          Pricing Model
          <i
            class="pi pi-info-circle text-xs text-muted-color cursor-pointer pl-1"
            pTooltip="Pricing models define the pricing parameters and the function (model) used for calculation. A model can calculate either the item cost and/or the item quantity depending on its predefined outputs."
            tooltipPosition="right"
          ></i>
        </span>
        <div class="flex items-center gap-2 min-w-0">
          <p-select
            [ngModel]="editForm.pricingModel().value()"
            (ngModelChange)="setControlValue(editForm.pricingModel, $event)"
            [ngModelOptions]="{ standalone: true }"
            (onChange)="markTouched(editForm.pricingModel)"
            [disabled]="editForm.pricingModel().disabled()"
            [options]="pricingModelService.selectOptions()"
            optionLabel="name"
            optionValue="id"
            class="w-full"
            [filter]="true"
            filterBy="name"
          />
          @if (editForm.pricingModel().dirty()) {
            <p-button
              icon="pi pi-undo"
              severity="secondary"
              [rounded]="true"
              (onClick)="resetPricingModel()"
              size="small"
            />
          }
        </div>
      </div>

      @if (showAppPriceSetting()) {
        @if (tradeStudyToolFeaturesEnabled) {
          <div
            class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
          >
            <span class="text-sm text-surface-switch-600">Unit Cost</span>
            <div class="flex items-center gap-2 min-w-0">
              <p-inputNumber
                [ngModel]="editForm.unitCost().value()"
                (ngModelChange)="setControlValue(editForm.unitCost, $event)"
                [ngModelOptions]="{ standalone: true }"
                (onBlur)="markTouched(editForm.unitCost)"
                [readonly]="editForm.unitCost().readonly()"
                [disabled]="editForm.unitCost().disabled()"
                [min]="-9999999"
                [max]="9999999"
                [mode]="'currency'"
                [currency]="currencyCode"
                locale="en-US"
                class="w-full"
                inputStyleClass="w-full"
              />
              @if (editForm.unitCost().dirty()) {
                <p-button
                  icon="pi pi-undo"
                  severity="secondary"
                  [rounded]="true"
                  (onClick)="resetUnitCost()"
                  size="small"
                />
              }
            </div>
          </div>
        } @else {
          <div
            class="flex xl:flex-row flex-col justify-between items-end xl:items-center gap-4 py-2.5 border-b border-surface-switch-100"
          >
            <span class="text-sm text-surface-switch-600 hidden xl:inline"
              >Unit Price</span
            >
            <app-price-setting
              [costField]="editForm.unitCost"
              [markupField]="editForm.unitMarkup"
              [markupPercentField]="editForm.unitMarkupPercent"
              [priceField]="editForm.unitPrice"
              costLabel="Unit Cost"
              priceLabel="Unit Price"
              [currencyCode]="currencyCode"
            />
          </div>
        }
      } @else {
        <div
          class="grid grid-cols-2 items-start gap-4 py-2.5 border-b border-surface-switch-100"
        >
          <span class="text-sm text-surface-switch-600 pt-2">Unit Cost</span>
          <div class="flex flex-col gap-1 min-w-0">
            <div class="flex items-center gap-2 min-w-0">
              <p-inputNumber
                [ngModel]="editForm.unitCost().value()"
                (ngModelChange)="setControlValue(editForm.unitCost, $event)"
                [ngModelOptions]="{ standalone: true }"
                (onBlur)="markTouched(editForm.unitCost)"
                [readonly]="editForm.unitCost().readonly()"
                [disabled]="editForm.unitCost().disabled()"
                [min]="-9999999"
                [max]="9999999"
                [mode]="'currency'"
                [currency]="currencyCode"
                locale="en-US"
                class="w-full"
                inputStyleClass="w-full"
                [class.opacity-60]="editForm.unitCost().readonly()"
              />
            </div>
            @if (editForm.unitCost().readonly()) {
              <p class="text-xs py-1 text-muted-color italic">
                Set by Pricing Model
              </p>
            }
          </div>
        </div>
        @if (!tradeStudyToolFeaturesEnabled) {
          <div
            class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
          >
            <span class="text-sm text-surface-switch-600">Markup %</span>
            <div class="min-w-0">
              <p-inputNumber
                [ngModel]="editForm.unitMarkupPercent().value()"
                (ngModelChange)="
                  setControlValue(editForm.unitMarkupPercent, $event)
                "
                [ngModelOptions]="{ standalone: true }"
                (onBlur)="markTouched(editForm.unitMarkupPercent)"
                [disabled]="editForm.unitMarkupPercent().disabled()"
                [showButtons]="true"
                [min]="-999"
                [max]="999"
                [suffix]="'%'"
                [minFractionDigits]="0"
                [maxFractionDigits]="2"
                class="w-full"
                inputStyleClass="w-full"
              />
            </div>
          </div>
        }
      }

      @if (!tradeStudyToolFeaturesEnabled) {
        <div
          class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
        >
          <span class="text-sm text-surface-switch-600">Tax</span>
          <div class="flex flex-col gap-1 min-w-0">
            <div class="flex items-center gap-2 min-w-0">
              <app-tax-code-select
                [formField]="editForm.taxCodePercentage"
                [displayLabel]="false"
                [isNewItem]="false"
                valueOutput="percentage"
                [fullWidth]="true"
                class="block w-full flex-1 min-w-0"
              />
              @if (editForm.taxCodePercentage().dirty()) {
                <p-button
                  icon="pi pi-undo"
                  severity="secondary"
                  [rounded]="true"
                  (onClick)="resetTaxCodePercentage()"
                  size="small"
                />
              }
            </div>
            @if (showAppPriceSetting()) {
              <p class="text-xs py-1 text-muted-color italic">
                Results in unit total of
                {{
                  unitTotalWithTax()
                    | currency: currencyCode : "symbol" : "1.2-2"
                }}
              </p>
            }
          </div>
        </div>
      }
    }

    <div
      class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
    >
      <span class="text-sm text-surface-switch-600 flex items-center gap-1">
        Quantity Scaling
        <i
          class="pi pi-info-circle text-xs text-muted-color cursor-pointer pl-1"
          pTooltip="Controls whether price scales with quantity. Scaled means total price changes with quantity; fixed means price stays the same regardless of quantity."
          tooltipPosition="right"
        ></i>
      </span>
      <div class="flex items-center gap-2 min-w-0">
        <p-select
          [ngModel]="editForm.quantityMode().value()"
          (ngModelChange)="setControlValue(editForm.quantityMode, $event)"
          [ngModelOptions]="{ standalone: true }"
          (onChange)="markTouched(editForm.quantityMode)"
          [options]="quantityModeOptions"
          optionLabel="label"
          optionValue="value"
          class="w-full"
        />
        @if (editForm.quantityMode().dirty()) {
          <p-button
            icon="pi pi-undo"
            severity="secondary"
            [rounded]="true"
            (onClick)="resetQuantityMode()"
            size="small"
          />
        }
      </div>
    </div>

    <div
      class="grid grid-cols-2 items-start gap-4 py-2.5 border-b border-surface-switch-100"
    >
      <span class="text-sm text-surface-switch-600 pt-2">Quantity Type</span>
      <div class="flex flex-col gap-1 min-w-0">
        <div class="flex items-center gap-2 min-w-0">
          <p-select
            [ngModel]="editForm.quantityType().value()"
            (ngModelChange)="setControlValue(editForm.quantityType, $event)"
            [ngModelOptions]="{ standalone: true }"
            (onChange)="markTouched(editForm.quantityType)"
            [disabled]="editForm.quantityType().disabled()"
            [options]="quantityTypeOptions()"
            optionLabel="label"
            optionValue="value"
            class="w-full"
          />
          @if (editForm.quantityType().dirty()) {
            <p-button
              icon="pi pi-undo"
              severity="secondary"
              [rounded]="true"
              (onClick)="resetQuantityType()"
              size="small"
            />
          }
        </div>
        @if (selectedPricingModelHasOutputQuantity()) {
          <p class="text-xs py-1 text-muted-color italic">
            Set by Pricing Model
          </p>
        }
      </div>
    </div>

    <div
      class="grid grid-cols-2 items-start gap-4 py-2.5 border-b border-surface-switch-100"
    >
      <span class="text-sm text-surface-switch-600 pt-2">Quantity</span>
      <div class="flex flex-col gap-1 min-w-0">
        <div class="flex items-center gap-2 min-w-0">
          @if (editForm.quantityType().value() == QuantityType.HOURLY) {
            <div class="flex flex-1 min-w-0 items-center gap-2">
              <p-floatlabel variant="on" class="flex-1 min-w-0">
                <p-inputNumber
                  inputId="quantity-hours"
                  class="w-full"
                  [ngModel]="editForm.quantityHours().value()"
                  (ngModelChange)="
                    setControlValue(editForm.quantityHours, $event)
                  "
                  [ngModelOptions]="{ standalone: true }"
                  (onBlur)="markTouched(editForm.quantityHours)"
                  [readonly]="editForm.quantityHours().readonly()"
                  [disabled]="editForm.quantityHours().disabled()"
                  [min]="0"
                  [max]="999999"
                  inputStyleClass="w-full"
                  [class.opacity-60]="selectedPricingModelHasOutputQuantity()"
                />
                <label for="quantity-hours">hours</label>
              </p-floatlabel>
              <p-floatlabel variant="on" class="flex-1 min-w-0">
                <p-inputNumber
                  inputId="quantity-mins"
                  class="w-full"
                  [ngModel]="editForm.quantityMins().value()"
                  (ngModelChange)="
                    setControlValue(editForm.quantityMins, $event)
                  "
                  [ngModelOptions]="{ standalone: true }"
                  (onBlur)="markTouched(editForm.quantityMins)"
                  [readonly]="editForm.quantityMins().readonly()"
                  [disabled]="editForm.quantityMins().disabled()"
                  [min]="-1"
                  [max]="60"
                  inputStyleClass="w-full"
                  [class.opacity-60]="selectedPricingModelHasOutputQuantity()"
                />
                <label for="quantity-mins">minutes</label>
              </p-floatlabel>
              <p-floatlabel variant="on" class="flex-1 min-w-0">
                <p-inputNumber
                  inputId="quantity-secs"
                  class="w-full"
                  [ngModel]="editForm.quantitySecs().value()"
                  (ngModelChange)="
                    setControlValue(editForm.quantitySecs, $event)
                  "
                  [ngModelOptions]="{ standalone: true }"
                  (onBlur)="markTouched(editForm.quantitySecs)"
                  [readonly]="editForm.quantitySecs().readonly()"
                  [disabled]="editForm.quantitySecs().disabled()"
                  [min]="-1"
                  [max]="60"
                  inputStyleClass="w-full"
                  [class.opacity-60]="selectedPricingModelHasOutputQuantity()"
                />
                <label for="quantity-secs">seconds</label>
              </p-floatlabel>
            </div>
          } @else {
            <div class="flex-1 min-w-0">
              <p-inputNumber
                class="block w-full"
                [ngModel]="editForm.quantity().value()"
                (ngModelChange)="setControlValue(editForm.quantity, $event)"
                [ngModelOptions]="{ standalone: true }"
                (onBlur)="markTouched(editForm.quantity)"
                [readonly]="editForm.quantity().readonly()"
                [disabled]="editForm.quantity().disabled()"
                [min]="0.000001"
                [max]="999999"
                [maxFractionDigits]="6"
                inputStyleClass="w-full"
                [class.opacity-60]="selectedPricingModelHasOutputQuantity()"
              />
            </div>
          }
          @if (editForm.quantity().dirty()) {
            <p-button
              icon="pi pi-undo"
              severity="secondary"
              [rounded]="true"
              (onClick)="resetQuantityValue()"
              size="small"
            />
          }
        </div>
        @if (selectedPricingModelHasOutputQuantity()) {
          <p class="text-xs py-1 text-muted-color italic">
            Set by Pricing Model
          </p>
        }
      </div>
    </div>

    <div
      class="grid grid-cols-2 items-start gap-4 py-2.5 border-b border-surface-switch-100"
    >
      <span
        class="text-sm text-surface-switch-600 pt-2 flex items-center gap-1"
      >
        Batch Size
        <i
          class="pi pi-info-circle text-xs text-muted-color cursor-pointer pl-1"
          pTooltip="Parts processed in one batch run. If the total quantity needs more parts, additional batches are added."
          tooltipPosition="right"
        ></i>
      </span>
      <div class="flex flex-col gap-1 min-w-0">
        <div class="flex items-center gap-2 min-w-0">
          <p-inputNumber
            class="block w-full"
            [ngModel]="editForm.batchSize().value()"
            (ngModelChange)="setControlValue(editForm.batchSize, $event)"
            [ngModelOptions]="{ standalone: true }"
            (onBlur)="markTouched(editForm.batchSize)"
            [min]="0"
            [max]="999999"
            [maxFractionDigits]="0"
            inputStyleClass="w-full"
          />
          @if (editForm.batchSize().dirty()) {
            <p-button
              icon="pi pi-undo"
              severity="secondary"
              [rounded]="true"
              (onClick)="resetBatchSize()"
              size="small"
            />
          }
        </div>
        @if (hasBatchSize()) {
          <p class="text-xs py-1 text-muted-color italic">
            This operation can process up to
            {{ editForm.batchSize().value() }} parts in one batch. Quantity and
            rate describe a single batch run — the parent total is that cost
            multiplied by the number of batches needed.
          </p>
        }
      </div>
    </div>

    @if (item.parent_chain && item.parent_chain.length > 0) {
      @if (item.cad_objects.length === 0) {
        <div
          class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
        >
          <span class="text-sm text-surface-switch-600 flex items-center gap-1">
            Inherit CAD From
            <i
              class="pi pi-info-circle text-xs text-muted-color cursor-pointer pl-1"
              pTooltip="Overrides which ancestor CAD is used for pricing. Default uses the closest ancestor with CAD objects."
              tooltipPosition="right"
            ></i>
          </span>
          <div class="flex items-center gap-2 min-w-0">
            <p-select
              [ngModel]="editForm.cadInheritedFromOverride().value()"
              (ngModelChange)="
                setControlValue(editForm.cadInheritedFromOverride, $event)
              "
              [ngModelOptions]="{ standalone: true }"
              (onChange)="markTouched(editForm.cadInheritedFromOverride)"
              [disabled]="editForm.cadInheritedFromOverride().disabled()"
              [options]="cadInheritOptions"
              optionLabel="name"
              optionValue="id"
              placeholder="Default"
              class="w-full"
            />
            @if (editForm.cadInheritedFromOverride().dirty()) {
              <p-button
                icon="pi pi-undo"
                severity="secondary"
                [rounded]="true"
                (onClick)="resetCadInheritedFromOverride()"
                size="small"
              />
            }
          </div>
        </div>
      }
    }

    <p-divider />

    <div class="flex flex-col">
      <div
        class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
      >
        <span class="text-sm text-surface-switch-600">Children</span>
        <span class="text-sm font-medium text-right">{{ childCount }}</span>
      </div>
      <div
        class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
      >
        <span class="text-sm text-surface-switch-600">Created At</span>
        <span class="text-sm font-medium text-right">{{
          item.created_date | date: "medium"
        }}</span>
      </div>
      @if (sheetSizeLabel) {
        <div
          class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
        >
          <span class="text-sm text-surface-switch-600">Sheet Size</span>
          <span class="text-sm font-medium text-right">{{
            sheetSizeLabel
          }}</span>
        </div>
      }
      @if (item.fixed_costs) {
        <div
          class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
        >
          <span class="text-sm text-surface-switch-600">Fixed Costs</span>
          <span class="text-sm font-medium text-right">{{
            item.fixed_costs | currency: currencyCode
          }}</span>
        </div>
      }
      @if (item.fixed_price) {
        <div
          class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
        >
          <span class="text-sm text-surface-switch-600">Fixed Price</span>
          <span class="text-sm font-medium text-right">{{
            item.fixed_price | currency: currencyCode
          }}</span>
        </div>
      }
      @if (item.cad_inherited_from_name) {
        <div
          class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
        >
          <span class="text-sm text-surface-switch-600">Inherited From</span>
          <span class="text-sm font-medium text-right">{{
            item.cad_inherited_from_name
          }}</span>
        </div>
      }
      <div
        class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
      >
        <span class="text-sm text-surface-switch-600">Unit Cost</span>
        <span class="text-sm font-medium text-right">{{
          item.unit_cost | currency: currencyCode
        }}</span>
      </div>
      <div
        class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
      >
        <span class="text-sm text-surface-switch-600">Unit Price</span>
        <span class="text-sm font-medium text-right">{{
          item.unit_price | currency: currencyCode
        }}</span>
      </div>
      <div
        class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
      >
        <span class="text-sm text-surface-switch-600">Subtotal</span>
        <span class="text-sm font-medium text-right">{{
          item.subtotal_price | currency: currencyCode
        }}</span>
      </div>
      @if (!tradeStudyToolFeaturesEnabled) {
        <div
          class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
        >
          <span class="text-sm text-surface-switch-600">Unit Tax</span>
          <span class="text-sm font-medium text-right">
            @if (item.unit_tax != null) {
              {{ item.unit_tax | currency: currencyCode }}
            } @else {
              -
            }
          </span>
        </div>
        <div
          class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
        >
          <span class="text-sm text-surface-switch-600">Subtotal Tax</span>
          <span class="text-sm font-medium text-right">
            @if (item.subtotal_tax != null) {
              {{ item.subtotal_tax | currency: currencyCode }}
            } @else {
              -
            }
          </span>
        </div>
      }
      <div
        class="grid grid-cols-2 items-center gap-4 py-2.5 border-b border-surface-switch-100"
      >
        <span class="text-sm text-surface-switch-600">Total Cost</span>
        <span class="text-sm font-medium text-right">{{
          item.total_price | currency: currencyCode
        }}</span>
      </div>
    </div>

    @if (editForm().dirty()) {
      <div
        class="sticky -bottom-1 left-0 right-0 mt-4 -mx-2 px-2 pr-4 py-3 border-t border-surface-switch-200 bg-surface-switch-0"
      >
        @if (saveError) {
          <p-message severity="error" styleClass="w-full mb-3">{{
            saveError
          }}</p-message>
        }
        <div class="flex justify-end gap-2">
          <p-button
            label="Cancel"
            icon="pi pi-times"
            severity="secondary"
            (onClick)="cancelChanges()"
            [disabled]="isSaving()"
          />
          <p-button
            label="Save"
            icon="pi pi-check"
            severity="primary"
            (onClick)="saveChanges()"
            [disabled]="!editForm().dirty() || editForm().invalid()"
            [loading]="isSaving()"
          />
        </div>
      </div>
    }
  </form>
}
